<template>
    <div>
        <div class="text-center" v-if="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <v-stepper v-model="stepper" alt-labels class="borderless shadowless py-0 mt-4">
                <v-stepper-header class="borderless shadowless">

                    <v-stepper-step :complete="stepper > 1" step="1" class="text-xs-center">Informations
                        d'identification</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 2" step="2" class="text-xs-center">Informations
                        professionnelles</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 3" step="3" class="text-xs-center">Informations de
                        localisation</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="4" class="text-xs-center">Informations de contact</v-stepper-step>

                </v-stepper-header>

                <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
                    {{ snackbar_message }}
                </v-snackbar>

                <v-stepper-items class="mt-4">
                    <v-form ref="form">
                        <v-stepper-content step="1">
                            <v-card flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations d'identification</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm4 align-center layout>
                                                <v-avatar size="256px" v-ripple
                                                    v-if="actor.photo_url != null && actor.photo_url.length != 0"
                                                    class="mb-3">
                                                    <img :src="`${actor.photo_url}`" alt="avatar">
                                                </v-avatar>
                                                <image-input v-model="avatar" v-else>
                                                    <div slot="activator">
                                                        <v-avatar size="256px" v-ripple
                                                            v-if="!avatar && (actor.photo_url === null || actor.photo_url.length === 0)"
                                                            class="grey lighten-3 mb-3">
                                                            <span>Click to add avatar</span>
                                                        </v-avatar>
                                                        <v-avatar size="256px" v-ripple v-else class="mb-3">
                                                            <img :src="avatar.imageURL" alt="avatar">
                                                        </v-avatar>
                                                    </div>
                                                </image-input>
                                                <v-slide-x-transition>
                                                    <div v-if="avatar && saved == false">
                                                        <v-btn class="primary ml-2" @click="uploadImage"
                                                            :loading="saving">Save Avatar</v-btn>
                                                    </div>
                                                </v-slide-x-transition>
                                            </v-flex>

                                            <v-flex xs12 sm8>
                                                <v-container fluid>
                                                    <v-layout row wrap align-center>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Nom</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.last_name" label="Nom" value=""
                                                                solo v-validate="'required'"
                                                                :error-messages="errors.collect('nom')"
                                                                data-vv-name="nom" required></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Prenom</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.first_name" label="Prenom"
                                                                value="" v-validate="'required'"
                                                                :error-messages="errors.collect('prenom')"
                                                                data-vv-name="prenom" required solo></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Surnom</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.nickname" label="Surnom"
                                                                value="" v-validate="'required'"
                                                                hint="Son nom populaire avec lequel on le connaît"
                                                                persistent-hint
                                                                :error-messages="errors.collect('nickname')"
                                                                data-vv-name="nickname" solo></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Sexe</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-select v-model="actor.gender" :items="genders"
                                                                label="Sexe" solo v-validate="'required'"
                                                                :error-messages="errors.collect('sexe')"
                                                                data-vv-name="sexe" required></v-select>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Age</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.age" type="number" label="Age"
                                                                solo
                                                                v-validate="'required|numeric|min_value:18|max_value:99'"
                                                                :error-messages="errors.collect('age')"
                                                                data-vv-name="age" required></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Langue</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-select v-model="actor.language" label="Langue"
                                                                :items="languages" item-text="name" item-value="name"
                                                                item-key="id" solo v-validate="'required'"
                                                                :error-messages="errors.collect('langue')"
                                                                data-vv-name="langue" required></v-select>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Niveau d'instruction</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-select v-model="actor.instruction_level"
                                                                :items="school_levels" item-text="name"
                                                                item-value="name" item-key="id"
                                                                label="Niveau d'instruction" solo
                                                                v-validate="'required'"
                                                                :error-messages="errors.collect('niveau')"
                                                                data-vv-name="niveau" required></v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()">Quitter</v-btn>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(1)"
                                        v-if="$can('create actors')">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-card class="mb-2" flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations professionnelles</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Chaine de valeur</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.value_chain_id" :items="chains"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir la chaine de valeur" solo v-validate="'required'"
                                                    :error-messages="errors.collect('chaine')" data-vv-name="chaine"
                                                    required>
                                                </v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Type d'acteur</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.type" :items="actor_types" item-text="name"
                                                    item-value="name" item-key="id" label="Choisir le type" solo
                                                    @change="loadMaillons()" v-validate="'required'"
                                                    :error-messages="errors.collect('type')" data-vv-name="type"
                                                    required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Maillon principal</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>

                                                <v-select v-model="actor.maillon_id" :items="filteredMaillons"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir le maillon" solo v-validate="'required'"
                                                    :error-messages="errors.collect('maillon')" data-vv-name="maillon"
                                                    required>
                                                </v-select>
                                            </v-flex>

                                            <v-flex xs6 sm4>
                                                <v-subheader>Maillons Secondaires</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.maillons" :items="filteredMaillons"
                                                    item-text="name" item-value="id" label="Choisir le(s) maillon(s)"
                                                    solo multiple chips deletable-chips v-validate="'required'"
                                                    :error-messages="errors.collect('maillon')" data-vv-name="maillons"
                                                    required></v-select>
                                            </v-flex>


                                            <!-- <v-flex xs6 sm4>
                                                <v-subheader>Services Demandés</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.services" :items="services" item-text="name"
                                                    item-value="id" label="Choisir le(s) services" solo multiple chips
                                                    deletable-chips data-vv-name="service" required></v-select>
                                            </v-flex> -->
                                            <!-- <v-flex xs6 sm4>
                                                <v-subheader>Êtes-vous membre d'une organisation?</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-radio-group v-model="select" inline>
                                                    <v-radio label="Non" value="Non" color="primary"></v-radio>
                                                    <v-radio label="Oui" value="Oui" color="primary"></v-radio>
                                                </v-radio-group>
                                            </v-flex> -->
                                            <v-layout>
                                                <v-flex xs6 sm4>
                                                    <v-subheader>Organisation</v-subheader>
                                                </v-flex>
                                                <v-flex xs6 sm8>
                                                    <v-autocomplete v-model="actor.organization_id"
                                                        :items="organisations" item-text="name" item-value="id"
                                                        item-key="id" label="Choisir l'organisation" solo clearable
                                                        v-validate="'required'"
                                                        :error-messages="errors.collect('organisation')"
                                                        data-vv-name="organisation" required>
                                                        <template v-slot:item="data">
                                                            <template v-if="typeof data.item !== 'object'">
                                                                <v-list-tile-content
                                                                    v-text="data.item"></v-list-tile-content>
                                                            </template>
                                                            <template v-else>
                                                                <v-list-item-content>
                                                                    <v-list-item-title
                                                                        v-html="data.item.name"></v-list-item-title>
                                                                    <v-list-item-subtitle v-if="data.item.town"
                                                                        v-html="data.item.town.name">
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </template>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()">Quitter</v-btn>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 1">Précédent</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(2)">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card class="mb-2" flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations de localisation</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Pays</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.country_id" :items="countries" item-text="name"
                                                    item-value="id" item-key="id" label="Choisir le pays" solo
                                                    v-validate="'required'" :error-messages="errors.collect('pays')"
                                                    data-vv-name="pays" required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Departement</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.department_id" :items="departments"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir le departement" solo @change="loadMunicipalities()"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('departement')"
                                                    data-vv-name="departement" required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Commune</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.municipality_id"
                                                    :items="filteredMunicipalities" item-text="name" item-value="id"
                                                    item-key="id" label="Choisir la commune" solo
                                                    @change="loadDistricts()" v-validate="'required'"
                                                    :error-messages="errors.collect('commune')" data-vv-name="commune"
                                                    required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Arrondissement</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.district_id" :items="filteredDistricts"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir l'arrondissement" solo @change="loadTowns()"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('arrondissement')"
                                                    data-vv-name="arrondissement" required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Village</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.town_id" :items="filteredTowns"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir la ville/village" solo v-validate="'required'"
                                                    :error-messages="errors.collect('village')" data-vv-name="village"
                                                    required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Adresse Physique</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-textarea v-model="actor.address" label="Entrer votre adresse"
                                                    maxlength="80" rows="2" full-width solo></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()"> Quitter</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 2">Précédent</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(3)">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-card class="mb-2" flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations de contact</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Contacts</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-combobox multiple v-model="actor.contact" label="Contact" solo chips
                                                    deletable-chips class="tag-input" :search-input.sync="search"
                                                    @keyup.tab="updateContacts" @paste="updateContacts"
                                                    v-validate="'required|numeric|min:8|max:8'"
                                                    :error-messages="errors.collect('contact')" data-vv-name="contact"
                                                    required>
                                                </v-combobox>
                                            </v-flex>
                                            <!-- <v-flex xs12 sm8 offset-sm-4>
                                                <v-checkbox v-model="checkbox"
                                                    label="L'acteur dispose-t-il d'un contact Whatsapp?" required
                                                    color="primary"></v-checkbox>
                                            </v-flex> -->
                                            <v-layout>
                                                <v-flex xs6 sm4>
                                                    <v-subheader>Contact du référent (personne à contacter en cas
                                                        d’urgence)</v-subheader>
                                                </v-flex>
                                                <v-flex xs6 sm8>
                                                    <v-text-field v-model="actor.contact_whatsapp"
                                                        v-validate="'required|numeric|min:8|max:8'"
                                                        label="Contact du référent" solo required></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()">Quitter</v-btn>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 3">Précédent</v-btn>
                                    <v-btn :loading="loading" :disabled="loading" @click="save()" color="primary"
                                        rounded>Enregistrer </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-form>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>
</template>
<script>
import ImageInput from '~/components/ImageInput.vue'
import Form from 'vform'
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
// import { Map, tileLayer, marker, icon } from 'leaflet'
import L from 'leaflet'
import Permissions from '~/mixins/Permissions';

export default {
    name: 'actor-edit-view',
    mixins: [Permissions],
    data: () => ({
        map: null,
        loader: false,
        stepper: 0,
        checkbox: false,
        public_actor: false,
        economic_actor: false,
        snackbar: false,
        snackbar_timeout: 5000,
        snackbar_color: "",
        actor: {
            first_name: '',
            last_name: '',
            nickname: '',
            gender: '',
            age: '',
            instruction_level: '',
            type: '',
            fonction: '',
            photo_url: null,
            organization_id: null,
            language: '',
            maillons: [],
            value_chain_id: null,
            country_id: null,
            department_id: null,
            municipality_id: null,
            district_id: null,
            town_id: null,
            address: '',
            longitude: null,
            latitude: null,
            altitude: null,
            precision: null,
            contact: [],
            services: [],
            contact_whatsapp: ''
        },
        search: '',
        // ages: ['< ou =35 ans', '>35 ans'],
        avatar: null,
        genders: ['Homme', 'Femme'],
        saving: false,
        saved: false,
        loading: false,
        edit_mode: false,
        actorId: null,
        photo: null,
        snackbar_message: '',
        cancel_message: 'Annuler',
        filterCount: 0,
        errorsDictionnary: {
            stepFields: {
                step1: ['nom', 'prenom', 'sexe', 'age', 'langue', 'niveau'],
                step2: ['type', 'maillon', 'maillons', 'chaine', 'organisation'],
                step3: ['pays', 'departement', 'commune', 'arrondissement', 'village'],
                step4: ['contact']
            }
        },
        selectedType: null,
        select: "Non",
        organisations: [],
        countries: []
    }),
    components: {
        ImageInput: ImageInput
    },
    created() {
        this.$checkPermission('edit own actors')
        this.actorId = this.$route.params.actorId
        this.edit_mode = true

        this.fetchCurrentActor()
        // this.fetchCountries()
        this.fetchDepartments()
        this.fetchActorTypes()
        this.fetchSchoolLevels()
        this.fetchLanguages()
        this.fetchMaillons()
        this.fetchChains()
        // this.fetchServices()
        // this.fetchMunicipalities()
        // this.fetchDistricts()
        // this.fetchTowns()
        this.fetchOrganisations()
        this.getUtils()
    },
    // mounted() {
    //     if (!this.edit_mode) {
    //         this.getLocation()
    //     }
    // },
    watch: {
        avatar: {
            handler: function () {
                this.saved = false
            },
            deep: true
        },
        'actor.type'(newVal, oldVal) {
            if (newVal && oldVal) {
                if (newVal != oldVal) {
                    this.actor.maillons = []
                }
            }

        }
    },
    computed: {
        filteredMunicipalities() { return this.$store.getters.getMunicipalities; },
        filteredDistricts() { return this.$store.getters.getDistricts; },
        filteredTowns() { return this.$store.getters.getTowns; },
        filteredMaillons: {
            // getter
            get: function () {
                if (this.actor.type == '' || this.selectedType == null) {
                    return this.$store.getters.maillons
                } else {
                    return this.$store.getters.maillons.filter(maillon => maillon.actor_type_id === this.selectedType.id)
                }
            },
            // setter
            set: function (newValue) {
                this.$store.commit('filterMaillons', newValue)
            }
        },
        ...mapGetters([
            // 'countries',
            'departments',
            'maillons',

            'chains',
            //'services',
            'languages',
            'actor_types',
            'school_levels'
        ])
    },

    methods: {
        updateContacts() {
            this.$nextTick(() => {
                this.actor.contact.push(...this.search.split(","));
                this.$nextTick(() => {
                    this.search = "";
                });
            });
        },

        checkActorType() {
            this.loadMaillons()
        },
        uploadImage() {
            this.saving = true
            setTimeout(() => this.savedAvatar(), 1000)
        },
        savedAvatar() {
            this.saving = false
            this.photo = this.avatar.imageFile
            this.saved = true
        },

        valideContacts() {
            if (this.actor.contact.length < 1 && (this.actor.contact_whatsapp == '' || this.actor.contact_whatsapp == null)) {
                return "Veuillez entrer le contact ou le contact du référent";
            }
            if (this.actor.contact.length > 0) {
                for (let i = 0; i < this.actor.contact.length; i++) {
                    if (!this.actor.contact[i]) {
                        return "Tous les contacts doivent être remplis.";
                    }

                    if (isNaN(this.actor.contact[i])) {
                        return "Les contacts doivent être numériques.";
                    }

                    if (this.actor.contact[i].length !== 8) {
                        return "Les contacts doivent comporter 8 chiffres.";
                    }
                }
            }
            if (this.actor.contact_whatsapp) {
                if (isNaN(this.actor.contact_whatsapp)) {
                    return "Le contact du référent doit être numérique.";
                }

                if (this.actor.contact_whatsapp.length < 8) {
                    return "Le contact du référent doit comporter 8 chiffres.";
                }
            }
            return true;
        },
        async save() {
            console.log({ 'maillons': this.actor.maillons });

            var validation = this.valideContacts()
            if (validation != true) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = validation;
                return;
            }
            // Save the actor.
            this.loading = true
            if (this.photo != null) {
                const config = { headers: { 'content-type': 'multipart/form-data' } }
                let formData = new FormData()
                formData.append("photo", this.photo)
                await axios.post("/api/upload-file", formData, config)
                    .then(response => {
                        this.actor.photo_url = response.data
                    });
            }

            if (this.edit_mode) {
                this.actor.services = this.actor.services.map(service => {
                    if (typeof service === 'object') {
                        return service.id
                    } else {
                        return service
                    }
                })


            }

            this.actor.maillons = this.actor.maillons.map(maillon => {
                if (typeof maillon === 'object') {
                    return maillon.id
                } else {
                    return maillon
                }
            })


            let newActor = {
                first_name: this.actor.first_name,
                last_name: this.actor.last_name,
                nickname: this.actor.nickname,
                gender: this.actor.gender,
                age: this.actor.age,
                instruction_level: this.actor.instruction_level,
                type: this.actor.type,
                fonction: this.actor.fonction,
                photo_url: this.actor.photo_url,
                organization_id: this.actor.organization_id,
                language: this.actor.language,
                maillon_id: this.actor.maillon_id,
                maillons: this.actor.maillons,
                value_chain_id: this.actor.value_chain_id,
                country_id: this.actor.country_id,
                department_id: this.actor.department_id,
                municipality_id: this.actor.municipality_id,
                district_id: this.actor.district_id,
                town_id: this.actor.town_id,
                address: this.actor.address,
                contact: this.actor.contact ? this.actor.contact.toString() : null,
                services: this.actor.services,
                longitude: this.actor.longitude,
                latitude: this.actor.latitude,
                altitude: this.actor.altitude,
                precision: this.actor.precision,
                contact_whatsapp: this.actor.contact_whatsapp
            }
            console.log(this.edit_mode, newActor);

            if (this.edit_mode) {
                this.updateActor(newActor)
            } else {
                this.saveActor(newActor)
            }
        },
        async saveActor(actor) {
            const { data } = await axios.post('/api/actors', actor)
            this.loading = false
            this.snackbar_message = "Acteur ajouté avec succès!"
            this.$root.$emit("action-event", this.snackbar_message);
            // Redirect to the actors list.
            this.$router.push({ name: 'actors.list' })
        },
        async updateActor(actor) {
            const { data } = await axios.put(`/api/actors/${this.actorId}`, actor)
            this.loading = false
            this.snackbar_message = "Acteur modifié avec succès!"
            this.$root.$emit("action-event", this.snackbar_message);
            // Redirect to the actors list.
            this.$router.push({ name: 'actors.list' })
        },

        loadMunicipalities() {
            this.$store.dispatch('loadMunicipalities', this.actor.department_id);
        },

        loadDistricts() {
            this.$store.dispatch('loadDistricts', this.actor.municipality_id);
        },

        loadTowns() {
            this.$store.dispatch('loadTowns', this.actor.district_id);
        },
        loadMaillons() {
            this.selectedType = this.actor_types.find(type => type.name === this.actor.type);
        },
        async nextStep(step) {
            let canStep = await this.stepCompleted(step)
            if (canStep) {
                this.stepper = parseInt(step) + 1
            }
        },
        async stepCompleted(step) {
            let stepField = this.errorsDictionnary.stepFields['step' + step]
            let validations = []
            for (let index = 0; index < stepField.length; index++) {
                const field = stepField[index];

                validations.push(this.$validator.validate(field))
            }
            const results = Promise.all([
                ...validations
            ]);

            const areValid = (await results).every(isValid => isValid);

            return areValid;
        },
        async fetchCurrentActor() {
            if (this.edit_mode) {
                this.loader = true
                this.cancel_message = 'Enrégistrer et quitter'
                const { data } = await axios.get(`/api/actors/${this.actorId}`)
                this.actor = data
                if (this.actor.contact) {
                    this.actor.contact = this.actor.contact.split(",")
                }
                this.checkActorType()
                if (this.actor.organization_id) {
                    this.select = "Oui"
                }
                if (this.actor.contact_whatsapp) {
                    this.checkbox = true
                }
                this.loader = false
                // this.$nextTick(function () {
                //     this.getPosition()
                // });
            }
        },
        getLocation() {
            if ("geolocation" in navigator) {
                var geo_options = {
                    enableHighAccuracy: true,
                    maximumAge: 30000,
                    timeout: 27000
                };
                navigator.geolocation.getCurrentPosition(this.showPosition, this.showError, geo_options);
            } else {
                this.$dialog.message.error('Geolocation is not supported by this browser.', {
                    position: 'top-center'
                })
            }
        },
        showPosition(position) {
            this.actor.latitude = position.coords.latitude
            this.actor.longitude = position.coords.longitude
            this.actor.altitude = position.coords.altitude
            this.actor.precision = position.coords.accuracy

            this.map = L.map(this.$refs['mapElement']).setView([this.actor.latitude, this.actor.longitude], 11);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                maxZoom: 18
            }).addTo(this.map);

            var myIcon = L.icon({
                iconUrl: window.config.appUrl + "/images/marker-icon.png",
                iconSize: [30, 50],
                iconAnchor: [25, 50],
                popupAnchor: [-3, -76],
            });
            var marker = L.marker([this.actor.latitude, this.actor.longitude], { icon: myIcon })
                .addTo(this.map)
                .bindPopup(
                    `<h2> Initial Location </h2> lat:<b>${this.actor.latitude}</b>, long:<b>${this.actor.longitude}</b>`
                );
            var self = this
            this.map.on('click', function (e) {
                var lat = e.latlng.lat.toFixed(7);
                var lon = e.latlng.lng.toFixed(7);
                self.actor.latitude = lat
                self.actor.longitude = lon

                if (marker != undefined) {
                    self.map.removeLayer(marker);
                };

                marker = L.marker([lat, lon], { icon: myIcon })
                    .addTo(self.map)
                    .bindPopup(
                        `<h2> Current Position </h2> lat:<b>${lat}</b>, long:<b>${lon}</b>`
                    );
            });
        },
        getPosition() {
            if (this.actor.latitude == null || this.actor.longitude == null) {
                this.getLocation()
            } else {
                this.map = L.map(this.$refs['mapElement']).setView([this.actor.latitude, this.actor.longitude], 11);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    maxZoom: 18
                }).addTo(this.map);

                var myIcon = L.icon({
                    iconUrl: window.config.appUrl + "/images/marker-icon.png",
                    iconSize: [30, 50],
                    iconAnchor: [25, 50],
                    popupAnchor: [-3, -76],
                });
                var marker = L.marker([this.actor.latitude, this.actor.longitude], { icon: myIcon })
                    .addTo(this.map)
                    .bindPopup(
                        `<h2> Initial Location </h2> lat:<b>${this.actor.latitude}</b>, long:<b>${this.actor.longitude}</b>`
                    );
                var self = this
                this.map.on('click', function (e) {
                    var lat = e.latlng.lat.toFixed(7);
                    var lon = e.latlng.lng.toFixed(7);
                    self.actor.latitude = lat
                    self.actor.longitude = lon

                    if (marker != undefined) {
                        self.map.removeLayer(marker);
                    };

                    marker = L.marker([lat, lon], { icon: myIcon })
                        .addTo(self.map)
                        .bindPopup(
                            `<h2> Current Position </h2> lat:<b>${lat}</b>, long:<b>${lon}</b>`
                        );
                });
            }
        },
        showError(error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    this.$dialog.message.error('User denied the request for Geolocation.', {
                        position: 'top-center'
                    })
                    break;
                case error.POSITION_UNAVAILABLE:
                    this.$dialog.message.error('Location information is unavailable.', {
                        position: 'top-center'
                    })
                    break;
                case error.TIMEOUT:
                    this.$dialog.message.error('The request to get user location timed out.', {
                        position: 'top-center'
                    })
                    break;
                case error.UNKNOWN_ERROR:
                    this.$dialog.message.error('An unknown error occurred.', {
                        position: 'top-center'
                    })
                    break;
            }
        },

        async quit() {
            this.$router.push({ name: 'actors.list' })

        },
        async cancel() {

            if (this.edit_mode) {
                await this.save()
            } else {
                this.$router.push({ name: 'actors.list' })
            }
        },
        ...mapActions({
            fetchCountries: 'fetchCountries',
            fetchDepartments: 'fetchDepartments',
            fetchMunicipalities: 'fetchMunicipalities',
            fetchDistricts: 'fetchDistricts',
            fetchTowns: 'fetchTowns',
            fetchActorTypes: 'fetchActorTypes',
            fetchSchoolLevels: 'fetchSchoolLevels',
            fetchLanguages: 'fetchLanguages',
            fetchMaillons: 'fetchMaillons',
            fetchChains: 'fetchChains',
            fetchServices: 'fetchServices',
            fetchOrganisations: 'fetchOrganisations',
            getUtils: 'getUtils'
        }),

        async getUtils() {
            const { data } = await axios.get('/api/countries')
            this.countries = data;
            this.loadMunicipalities()
            this.loadDistricts()
            this.loadTowns()
        },
        async fetchOrganisations() {
            const filteredDepartments = this.departments.filter(department => department.name == "COLLINES" || department.name == 'BORGOU' || department.name == 'DONGA');
            const departmentIds = filteredDepartments.map(department => department.id)
            const { data } = await axios.get('/api/organizations?include=town', { params: { 'department_ids': departmentIds } })
            this.organisations = data;
        },

    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
    }
}
</script>
<style scoped>
.v-stepper--alt-labels .v-stepper__step {
    justify-content: center;
    align-items: center;
    flex-basis: auto;
}

.theme--light.v-subheader {
    font-size: 1.3em;
    color: black;
}

.map-container {
    position: relative;
    height: 400px;
    width: 890px;
}

.map {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/edit.vue